import { Col, Row, Form } from 'react-bootstrap';
import { UseFormMethods } from 'react-hook-form';
import { SpecialFinancingParams } from '..';

interface SpecialFinancingFormProps {
    formParams: UseFormMethods<SpecialFinancingParams>;
    handleChanges: (event: any) => void;
    errors: any;
}

export default function SpecialFinancingForm({
    formParams,
    errors,
    handleChanges,
}: SpecialFinancingFormProps) {
    return (
        <Form>
            <Row>
                <Col md="12">
                    <Form.Group controlId="formBasicIsEnabled">
                        <Form.Check
                            ref={formParams.register}
                            id="formBasicIsEnabled"
                            name="isEnabled"
                            type="switch"
                            checked={formParams.watch('isEnabled')}
                            className="float-left"
                            onChange={handleChanges}
                        />

                        <Form.Label>Habilitar campanha</Form.Label>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group controlId="formBasicPartnerBank">
                        <Form.Label>Parceiro</Form.Label>
                        <Form.Control
                            ref={formParams.register}
                            name="partnerBank"
                            type="string"
                            className="form-control-nexen"
                            placeholder="Digite aqui..."
                            onChange={handleChanges}
                            isInvalid={!!errors.partnerBank}
                        />
                        {errors.partnerBank && (
                            <Form.Control.Feedback type="invalid">
                                {errors.partnerBank}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group controlId="formBasicObservation">
                        <Form.Label>Observação</Form.Label>
                        <Form.Control
                            ref={formParams.register}
                            name="observation"
                            type="string"
                            className="form-control-nexen"
                            placeholder="Digite aqui..."
                            onChange={handleChanges}
                            isInvalid={!!errors.observation}
                        />
                        {errors.observation && (
                            <Form.Control.Feedback type="invalid">
                                {errors.observation}
                            </Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
}
